module.exports = __webpack_public_path__ + "static/media/1000.9a5a9302.svg";